<article class="block-play-cta section-outset-b">
  <section class="container">
    <app-text-shape
      [autoplay]="false"
      class="block-play-cta__squiggle"
      type="standalone"
      data-speed="1"
      [shape]="'squiggle-05'"
      [shapeColor]="'secondary'"
      [startAnimation]="inviewPort"
    ></app-text-shape>
    <div class="row align-items-center">
      <div class="col-sm-7 block-play-cta__content">
        <h2 class="block-play-cta__content__title z-1 splitting splitting--letter-in" splitting>
          {{ block.title }}
          <a *ngIf="block.button?.url" [routerLink]="block.button?.url" class="icon-link anim-fade-up delay--2">
            <fstr-icon class="block-play-cta__icon" [anchor]="'icon-doodle-play-button'"></fstr-icon>
          </a>
        </h2>

        <!--<h2 class="fs-display-0 fst-italic header-play__title splitting splitting--letter-in" *ngIf="title || header?.title" splitting>
          <span>{{ title || header?.title }}</span>

          <app-text-shape class="header-play__title__shape" [type]="'standalone'" [autoplay]="true" [shapeColor]="'primary'"></app-text-shape>
        </h2>-->
      </div>
      <fstr-image
        class="z-0 col-sm-5 pull-s block-play-cta__image"
        [imageSizes]="[200, 400, 800, 900]"
        *ngIf="block.image"
        [image]="block.image"
        [alt]="block.image?.alt || block.title || 'block-image'"
      ></fstr-image>
    </div>
  </section>
</article>
